export const iconFontAwesomeGamingSteamSymbol = (
	<i className="fa-solid fa-steam-symbol"></i>
);
